import { SelectOption } from '@kep-ui-kit/ui-components';

export const subscriptionOptions: SelectOption[] = [
  { text: 'FREE', value: 'FREE' },
  { text: 'PAID', value: 'PAID' },
];
